<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.templateNav.overview')" link="templates" />
    <template v-if="!isNil(templates)">
      <template v-for="templateType in enums['TemplateDocument']">
        <item-nav-group v-if="!isEmpty(templates) && templateDocuments[templateType].systemTemplate === false" :open="templateType === activeItemType" :label="$t(`TemplateDocument.${templateType}`)" :key="templateType">
          <template v-for="template in templates" v-if="template.documentType === templateType && !template.deleted">
            <item-nav-group-item :label="getName(template)" :params="routeParams(template.id)" :key="template.id" link="template" />
          </template>
        </item-nav-group>
      </template>
      <item-nav-group v-if="!isEmpty(deletedTemplates)" :open="'deleted' === activeItemType" :label="$t('layout.nav.admin.templateNav.deletedTemplates')">
        <item-nav-group-item v-for="template in deletedTemplates"
                             :label="getName(template)"
                             :params="routeParams(template.id)"
                             :key="template.id"
                             link="template" />
      </item-nav-group>
    </template>
  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, keyBy, sortBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';
import TemplateMixin from '../../../../../mixins/TemplateMixin';

export default {
  name: 'TemplateNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin, TemplateMixin],
  props: [],

  data() {
    return {
    };
  },

  computed: {
    deletedTemplates: function () {
      return this.templates.filter(it => it.deleted === true);
    },
    activeItemType: function () {
      if (isEmpty(this.templates)) return null;

      const template = this.templates.find(it => it.id === this.$route.params.templateId);

      if (isNil(template)) return null;

      if (template.deleted === true) return 'deleted';

      return template.documentType;
    },
  },

  created: function () {
    this.updateTemplates();

    this.$serviceBus.$on('template.list', (data) => {
      if (isNil(data)) {
        this.updateTemplates();
      } else {
        this.templates = sortBy(data, ['documentType', 'name']);
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    updateTemplates() {
      this.axios.get(this.serviceUrls.template.list(this))
        .then((response) => {
          this.templates = sortBy(response.data.data, ['documentType', 'name']);
        });
    },
    getName(templ) {
      if (isNil(templ)) return '-';
      let ret = null;

      ret = templ.name;

      if (!isEmpty(ret)) return ret;

      return '-';
    },
    routeParams(templateId) {
      return {
        templateId: templateId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/TemplateNav.vue